var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "complete mt-40" },
    [
      _vm.isOrderLoading
        ? _c("loading")
        : _c("div", [
            !_vm.hasOrder
              ? _c(
                  "div",
                  { staticClass: "container mb-80" },
                  [
                    _c("blockCard", [
                      _c(
                        "div",
                        {
                          staticClass: "p-24 flex flex-col items-center",
                          attrs: { id: "invalid-order" },
                        },
                        [
                          _c("img", {
                            staticClass: "mb-32",
                            attrs: {
                              src: require("@/assets/img/hotel-img-grey.png"),
                              alt: "",
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "empty-notice flex items-center" },
                            [
                              _c("i", {
                                staticClass:
                                  "owl-status-triangle-warning text-orange text-2xl",
                              }),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-2xl font-medium text-grey-darkest",
                                },
                                [_vm._v(_vm._s(_vm.$t("checkNoOrder")))]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "container" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "order-status flex flex-col items-center mt-40 mb-8",
                      },
                      [
                        _c(
                          "h2",
                          { staticClass: "text-green-dark font-bold mb-16" },
                          [_vm._v(_vm._s(_vm.$t("agent-pay.title")))]
                        ),
                        _c("p", { staticClass: "text-grey-darkest text-sm" }, [
                          _vm._v(
                            "\n           " +
                              _vm._s(_vm.$t("agent-pay.description")) +
                              "\n          "
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "ml-2",
                              attrs: { href: "#select-payment" },
                            },
                            [_vm._v(_vm._s(_vm.$t("agent-pay.link")))]
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "blockCard",
                      { staticClass: "order-info", attrs: { noPadding: "" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "order-info__detail py-24 lg:p-24 border-b-1 border-grey-lighter",
                          },
                          [
                            _c("h4", { staticClass: "mb-24" }, [
                              _vm._v(_vm._s(_vm.$t("orderInformation"))),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "order-info__detail__date-participant text-grey-darkest mb-32",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "order-info__detail__date-participant mb-16",
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "owl-calendar mr-8 text-grey text-xl",
                                    }),
                                    _c("span", [_vm._v(_vm._s(_vm.dateRange))]),
                                    _c(
                                      "small",
                                      { staticClass: "ml-8 text-grey-dark" },
                                      [
                                        _vm._v(
                                          "( " +
                                            _vm._s(_vm.diffDays + 1) +
                                            " " +
                                            _vm._s(
                                              _vm.$tc("day", _vm.diffDays + 1)
                                            ) +
                                            " " +
                                            _vm._s(_vm.diffDays) +
                                            " " +
                                            _vm._s(
                                              _vm.$tc("night", _vm.diffDays)
                                            ) +
                                            " )"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "order-info__detail__date-participant",
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "owl-user-group mr-8 text-grey text-xl",
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.orderInfo.guest.adult) +
                                          " " +
                                          _vm._s(
                                            _vm.$tc(
                                              "adult",
                                              _vm.orderInfo.guest.adult
                                            )
                                          )
                                      ),
                                    ]),
                                    _vm.hotelReceptionConfig.child.isReceive
                                      ? _c("span", [
                                          _vm._v(
                                            ", " +
                                              _vm._s(
                                                _vm.orderInfo.guest.children
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.$tc(
                                                  "child",
                                                  _vm.orderInfo.guest.children
                                                )
                                              )
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.hotelReceptionConfig.infant.isReceive
                                      ? _c("span", [
                                          _vm._v(
                                            ", " +
                                              _vm._s(
                                                _vm.orderInfo.guest.infant
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.$tc(
                                                  "infant",
                                                  _vm.orderInfo.guest.infant
                                                )
                                              )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "template__info-group mb-24" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("orderNumber"))),
                                ]),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.orderInfo.order_serial)),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "template__info-group mb-24" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("orderNights"))),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.diffDaysCount) +
                                      " " +
                                      _vm._s(
                                        _vm.$tc("night", _vm.diffDaysCount)
                                      )
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "order-info__detail__amounts flex flex-col md:flex-row",
                              },
                              [
                                _vm.isShowRemainTotal
                                  ? _c(
                                      "div",
                                      { staticClass: "template__info-group" },
                                      [
                                        _c("label", [
                                          _vm._v(_vm._s(_vm.$t("remainTotal"))),
                                        ]),
                                        _c(
                                          "span",
                                          [
                                            _vm._v(
                                              _vm._s(_vm.orderInfo.currency) +
                                                " "
                                            ),
                                            _c(
                                              "big",
                                              {
                                                staticClass:
                                                  "text-blue font-bold",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("numeral")(
                                                      _vm.remainTotal
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.typeOfPaymentMethod === "collection"
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "template__info-group" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(_vm.$t("amountPaid"))
                                            ),
                                          ]),
                                          _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.orderInfo.currency) +
                                                "\n                  " +
                                                _vm._s(
                                                  _vm._f("numeral")(
                                                    _vm.paidDepositTotal
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "template__info-group" },
                                  [
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.$t("total"))),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-col md:flex-row",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.orderInfo.currency) +
                                              " " +
                                              _vm._s(
                                                _vm._f("numeral")(
                                                  _vm.orderInfo.order_total
                                                )
                                              )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              2
                            ),
                            _vm.hasExtraTaxFeeConfig
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "text-sm mt-16 text-grey-dark",
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "owl-status-triangle-warning text-orange",
                                    }),
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t("room_price_has_tax_included")
                                        ) +
                                        " " +
                                        _vm._s(_vm.orderInfo.currency) +
                                        " " +
                                        _vm._s(
                                          _vm._f("numeral")(_vm.totalExtraFee)
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "order-info__orderer py-24 lg:p-24" },
                          [
                            _c("div", { staticClass: "template__info-group" }, [
                              _c("label", [_vm._v(_vm._s(_vm.$t("lastName")))]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.orderInfo.lastname)),
                              ]),
                            ]),
                            _c("div", { staticClass: "template__info-group" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("firstName"))),
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.orderInfo.firstname)),
                              ]),
                            ]),
                            _c("div", { staticClass: "template__info-group" }, [
                              _c("label", [_vm._v(_vm._s(_vm.$t("country")))]),
                              _c("span", [_vm._v(_vm._s(_vm.countryName))]),
                            ]),
                            _c("div", { staticClass: "template__info-group" }, [
                              _c("label", [_vm._v(_vm._s(_vm.$t("phone")))]),
                              _c("span", [_vm._v(_vm._s(_vm.orderInfo.phone))]),
                            ]),
                            _c("div", { staticClass: "template__info-group" }, [
                              _c("label", [_vm._v(_vm._s(_vm.$t("email")))]),
                              _c("span", [_vm._v(_vm._s(_vm.orderInfo.email))]),
                            ]),
                          ]
                        ),
                        _vm.orderInfo.order_requirements
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "text-grey-darker text-sm py-24 lg:p-24 border-t border-grey-lighter",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "template__info-group" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("orderRequirements"))
                                      ),
                                    ]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.orderInfo.order_requirements)
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "hotel-orders" },
                      [
                        _c("h4", { staticClass: "py-24 font-bold" }, [
                          _vm._v(_vm._s(_vm.$t("roomTypeAndOrders"))),
                        ]),
                        _c(
                          "blockCard",
                          { attrs: { noPadding: "" } },
                          _vm._l(
                            _vm.roomsGroupByRoomName,
                            function (room, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass:
                                    "hotel-orders__order py-24 lg:p-24",
                                },
                                [
                                  _vm._l(room, function (plan, index) {
                                    return _c(
                                      "div",
                                      { key: `${plan.name}-${index}` },
                                      [
                                        _c(
                                          "h4",
                                          {
                                            staticClass:
                                              "text-grey-darker mb-16",
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.$convertI18nObj(
                                                    plan.room_name_i18n,
                                                    plan.room_name
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "hotel-orders__container rounded-sm shadow-md border-1 mb-16",
                                          },
                                          [
                                            _c("hotelOrder", {
                                              attrs: {
                                                plan: plan,
                                                orderInfo: _vm.orderInfo,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  }),
                                  _c("h6", { staticClass: "mb-16" }, [
                                    _vm._v(_vm._s(_vm.$t("cancelPolicy"))),
                                  ]),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "whitespace-pre-wrap text-grey-dark text-sm leading-normal",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$convertI18nObj(
                                            room[0].cancel_policy.content_i18n,
                                            room[0].cancel_policy.content |
                                              _vm.contentParser
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              )
                            }
                          ),
                          0
                        ),
                      ],
                      1
                    ),
                    _c(
                      "blockCard",
                      {
                        staticClass: "hotel-info",
                        attrs: { title: _vm.$t("hotelInfo") },
                      },
                      [
                        _c("div", { staticClass: "template__info-group" }, [
                          _c("label", [_vm._v(_vm._s(_vm.$t("hotel.name")))]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$convertI18nObj(
                                  _vm.orderInfo.hotel.name_i18n,
                                  _vm.orderInfo.hotel.name
                                )
                              )
                            ),
                          ]),
                        ]),
                        this["hotel/hotelDisplaySetting"].phone
                          ? _c("div", { staticClass: "template__info-group" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("hotel.phone"))),
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.orderInfo.hotel.phone)),
                              ]),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "template__info-group" }, [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("hotel.address"))),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.orderInfo.hotel.address)),
                          ]),
                        ]),
                        _c("div", { staticClass: "hotel-info__map" }, [
                          this["hotel/hotelLocatedBy"]
                            ? _c("iframe", {
                                staticStyle: { border: "0" },
                                attrs: {
                                  src: `https://www.google.com/maps/embed/v1/place?q=${encodeURI(
                                    this["hotel/hotelLocatedBy"]
                                  )}&key=${_vm.googleMapKey}`,
                                  width: "100%",
                                  height: "320",
                                  frameborder: "0",
                                  allowfullscreen: "",
                                },
                              })
                            : _vm._e(),
                        ]),
                      ]
                    ),
                    _c("h4", { staticClass: "py-24 font-bold" }, [
                      _vm._v(_vm._s(_vm.$t("agent-pay.link"))),
                    ]),
                    _c(
                      "blockCard",
                      {
                        staticClass: "payment-ways",
                        attrs: {
                          id: "select-payment",
                          title: _vm.$t("paymentType"),
                        },
                      },
                      [
                        _vm.isOrderAllowPay
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "payment-ways__options flex flex-col flex-wrap leading-loose md:flex-row md:items-center",
                              },
                              [
                                _vm._l(_vm.activedWays, function (way) {
                                  return [
                                    _vm.isApplePay(way.type)
                                      ? _c(
                                          "div",
                                          {
                                            key: way.type,
                                            staticClass:
                                              "payment-ways__options__option",
                                            on: {
                                              click: function ($event) {
                                                return _vm.onSelectPaymentWay(
                                                  way.type
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "owl-radio-wrap",
                                                class: {
                                                  disabled: _vm.isSubmitting,
                                                },
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    attrs: {
                                                      for: `payment-ways__options__option__${way.type}`,
                                                    },
                                                  },
                                                  [
                                                    _c("input", {
                                                      attrs: {
                                                        type: "radio",
                                                        id: `payment-ways__options__option__${way.type}`,
                                                        name: way.type,
                                                        disabled:
                                                          _vm.isSubmitting,
                                                      },
                                                      domProps: {
                                                        checked:
                                                          way.type ===
                                                          _vm.customer
                                                            .paymentWay,
                                                      },
                                                    }),
                                                    _c("div", {
                                                      staticClass: "owl-radio",
                                                    }),
                                                    _vm.paymentWayLogo(way.type)
                                                      ? [
                                                          _c("img", {
                                                            directives: [
                                                              {
                                                                name: "tippy",
                                                                rawName:
                                                                  "v-tippy",
                                                              },
                                                            ],
                                                            attrs: {
                                                              src: _vm.paymentWayLogo(
                                                                way.type
                                                              ),
                                                              alt: way.type,
                                                              title: _vm.$t(
                                                                way.type
                                                              ),
                                                            },
                                                          }),
                                                        ]
                                                      : [
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "tippy",
                                                                  rawName:
                                                                    "v-tippy",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "uppercase",
                                                              attrs: {
                                                                title: _vm.$t(
                                                                  way.type
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  way.type.includes(
                                                                    "atm"
                                                                  )
                                                                    ? _vm.$t(
                                                                        "atm-transfer"
                                                                      )
                                                                    : _vm.$t(
                                                                        way.type
                                                                      )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                  ],
                                                  2
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                }),
                              ],
                              2
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "text-orange flex items-center font-bold",
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "owl-status-triangle-warning mr-8",
                                }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("payments_not_allowed"))
                                  ),
                                ]),
                              ]
                            ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isInlineCreditCard,
                                expression: "isInlineCreditCard",
                              },
                            ],
                            staticClass:
                              "orderer-info border border-grey-light my-8 p-16 rounded",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-group w-full sm:w-1/2 sm:pr-24",
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "is-required",
                                    attrs: { for: "cardNumber" },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("cardNumber")))]
                                ),
                                _c("cleave", {
                                  staticClass: "input",
                                  class: {
                                    "input-error":
                                      _vm.validation.firstError(
                                        "stripeCard.number"
                                      ),
                                  },
                                  attrs: {
                                    options: _vm.cardNumberOptions,
                                    placeholder: "**** **** **** ****",
                                    disabled: _vm.isSubmitting,
                                  },
                                  model: {
                                    value: _vm.stripeCard.number,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.stripeCard, "number", $$v)
                                    },
                                    expression: "stripeCard.number",
                                  },
                                }),
                                _vm.validation.firstError("stripeCard.number")
                                  ? _c(
                                      "span",
                                      { staticClass: "format-error-notify" },
                                      [_vm._v(_vm._s(_vm.$t("errorMsg.empty")))]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-group w-full sm:w-1/2 sm:pr-24",
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "is-required",
                                    attrs: { for: "cardExpiryDate" },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("cardExpiryDate")))]
                                ),
                                _c("cleave", {
                                  staticClass: "input",
                                  class: {
                                    "input-error": _vm.validation.firstError(
                                      "stripeCard.expiryDate"
                                    ),
                                  },
                                  attrs: {
                                    options: _vm.expiryDateOptions,
                                    placeholder: "MM/YY",
                                    disabled: _vm.isSubmitting,
                                  },
                                  model: {
                                    value: _vm.stripeCard.expiryDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.stripeCard,
                                        "expiryDate",
                                        $$v
                                      )
                                    },
                                    expression: "stripeCard.expiryDate",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-group w-full sm:w-1/2 sm:pr-24",
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "is-required",
                                    attrs: { for: "cardCvc" },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("cardCvc")))]
                                ),
                                _c("cleave", {
                                  staticClass: "input",
                                  class: {
                                    "input-error":
                                      _vm.validation.firstError(
                                        "stripeCard.cvc"
                                      ),
                                  },
                                  attrs: {
                                    options: _vm.cvcOptions,
                                    placeholder: "***",
                                    disabled: _vm.isSubmitting,
                                  },
                                  model: {
                                    value: _vm.stripeCard.cvc,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.stripeCard, "cvc", $$v)
                                    },
                                    expression: "stripeCard.cvc",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.customer.paymentWay.includes(
                                        "paynow"
                                      ),
                                    expression:
                                      "customer.paymentWay.includes('paynow')",
                                  },
                                ],
                                staticClass:
                                  "form-group w-full sm:w-1/2 sm:pr-24",
                              },
                              [
                                _c("span", {
                                  staticClass: "text-sm text-grey-dark",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("payNowCreditCardNote")
                                    ),
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isStripeFuturePay,
                                expression: "isStripeFuturePay",
                              },
                            ],
                            attrs: { id: "stripe-payment-form" },
                          },
                          [
                            _c("div", { staticClass: "form-row" }, [
                              _c(
                                "label",
                                { attrs: { for: "stripe-card-element" } },
                                [_vm._v("Credit or debit card")]
                              ),
                              _c("div", { staticClass: "flex" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "stripe-card-element-input w-full mr-8",
                                  },
                                  [
                                    _c("div", {
                                      attrs: { id: "stripe-card-element" },
                                    }),
                                    _c("div", {
                                      attrs: {
                                        id: "stripe-card-errors",
                                        role: "alert",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _vm.customer.paymentWay === "atm"
                          ? _c(
                              "div",
                              { staticClass: "my-16 flex items-center" },
                              [
                                _c("i", {
                                  staticClass:
                                    "owl-status-triangle-warning text-orange text-xl mr-8",
                                }),
                                _c(
                                  "p",
                                  { staticClass: "text-grey-darkest text-sm" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("paymentNote.atm")) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "payment-agreement__row border-t-1 border-grey-lighter pt-24",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "owl-checkbox-wrap",
                                class: {
                                  error:
                                    _vm.validation.firstError(
                                      "isAgreementChecked"
                                    ),
                                  disabled: _vm.isSubmitting,
                                },
                              },
                              [
                                _vm.isTaiwan && _vm.isZhTw
                                  ? _c(
                                      "blockCard",
                                      { staticClass: "bg-orange-lightest" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "notice flex items-center mb-12",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "owl-status-triangle-warning text-orange text-xl mr-8",
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-grey-darkest text-sm",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "agentPayNotice.title"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "ul",
                                          { staticClass: "list-block" },
                                          [
                                            _c(
                                              "li",
                                              {
                                                staticClass:
                                                  "leading-normal text-grey-darkest text-sm whitespace-pre-wrap",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "agentPayNotice.payment"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("li", {
                                              staticClass:
                                                "leading-normal text-grey-darkest text-sm whitespace-pre-wrap",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t(
                                                    "agentPayNotice.antiFraud"
                                                  )
                                                ),
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "label",
                                  { attrs: { for: "payment-agreement" } },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.isAgreementChecked,
                                          expression: "isAgreementChecked",
                                        },
                                      ],
                                      class: { disabled: _vm.isSubmitting },
                                      attrs: {
                                        type: "checkbox",
                                        id: "payment-agreement",
                                        name: "payment-agreement",
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.isAgreementChecked
                                        )
                                          ? _vm._i(
                                              _vm.isAgreementChecked,
                                              null
                                            ) > -1
                                          : _vm.isAgreementChecked,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.isAgreementChecked,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.isAgreementChecked =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.isAgreementChecked = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.isAgreementChecked = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _c("div", { staticClass: "owl-checkbox" }),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("agreement"))),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "payment-agreement__row flex flex-col md:flex-row justify-end",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn md:btn-lg btn-solid btn-blue w-full md:w-auto md:px-80",
                                attrs: { disabled: _vm.isSubmitButtonDisabled },
                                on: { click: _vm.onSubmitBtnClick },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.isSubmitting,
                                        expression: "!isSubmitting",
                                      },
                                    ],
                                  },
                                  [_vm._v(_vm._s(_vm.$t("sendOrder")))]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isSubmitting,
                                        expression: "isSubmitting",
                                      },
                                    ],
                                  },
                                  [_vm._v(_vm._s(_vm.$t("processing")))]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }